import { Col, Row, Select, Form, Input } from "antd";
import { Modal } from "react-bootstrap";
import { useCountry } from "../../provider/courtryProvider";
import { useSelector } from "react-redux";
import { v4 } from "uuid";
import { useBilling } from "../Kitchen/billingProvider";
import { useState } from "react";

const UNIT = [
  "g",
  "kg",
  "mg",
  "ml",
  "L",
  "cup",
  "count",
  "box",
  "pkt",
  "glass",
  "cm",
  "m",
  "km",
  "min",
  "hour",
  "days",
  "inch",
  "Ton",
];

const AddBillModal = ({ open = false, onClose = () => {} }) => {
  const [form] = Form.useForm();
  const country = useCountry();
  const shopId = useSelector((state) => state.shopDetails.shopId);
  const taxList = useSelector((state) => state.taxList.taxList);
  const [isRequired, setIsRequired] = useState(false);
  const [isRequiredMeasurement, setIsRequiredMeasurement] = useState(false);
  const {
    addProductToBilling,
    state: { addedProducts },
  } = useBilling();
  const onFinish = (values) => {
    console.log("Success:", values);
    const product = {
      productId: v4(),
      ...values,
      unitOfMeasurment: values.measurmentValue
        ? values.measurmentValue + " " + values.measurmentUnit
        : "",
      measurmentValue: undefined,
      measurmentUnit: undefined,
      isExist: false,
      addedDate: new Date().toISOString().substring(0, 10),
      shopId: shopId,
      versionId: "1",
      inventoryQty: 0,
      latest: "true",
      category: "OTHERS",
      subCategory: "others",
      status: "new",
      productType: "product",
    };
    if (addedProducts.length !== 0) {
      const newItem = JSON.stringify(product);
      const products = addedProducts.map(
        ({
          productName,
          isExist,
          purchasePrice,
          count,
          imei2,
          taxIncExc,
          productEANCode,
          taxId,
          productTax,
          productTaxType,
          productPrice,
          productMrp,
          unitOfMeasurment,
          discountType,
          discountPrice,
          productWastage,
          productLabour,
          productHsnCode,
        }) => {
          return JSON.stringify({
            productName,
            isExist,
            purchasePrice,
            count,
            imei2,
            taxIncExc,
            productEANCode,
            taxId,
            productTax,
            productTaxType,
            productPrice,
            productMrp,
            unitOfMeasurment,
            discountType,
            discountPrice,
            productWastage,
            productLabour,
            productHsnCode,
          });
        }
      );
      const isExist = products.includes(`{${newItem}}`);
      if (isExist) {
        return alert("Product already exist");
      }
    }
    addProductToBilling(product);
    form.resetFields();
    setIsRequired(false);
    setIsRequiredMeasurement(false);
    onClose(false);
  };

  return (
    <Modal
      show={open}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      onHide={() => onClose(false)}
    >
      <Modal.Header closeButton>
        <div>
          <h3 style={{ color: "#EF4667" }}>Add Item to Bill</h3>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Form
          wrapperCol={{ span: 24 }}
          labelCol={{ span: 24 }}
          onFinish={onFinish}
          form={form}
        >
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                label="Product Name"
                name={"productName"}
                rules={[
                  {
                    required: true,
                    message: "Please enter product name",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Selling Price"
                name={"productPrice"}
                rules={[
                  {
                    required: true,
                    message: "Please enter Selling price",
                  },
                ]}
              >
                <Input type="number" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Product MRP" name={"productMrp"}>
                <Input type="number" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Item Barcode" name={"productEANCode"}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={`Purchase Price (${country.CurrencySymbol})`}
                name="purchasePrice"
              >
                <Input type="number" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Quantity"
                name={"count"}
                rules={[
                  {
                    required: true,
                    message: "Please enter Quantity",
                  },
                ]}
              >
                <Input type="number" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Row>
                <Col span={18}>
                  <Form.Item
                    rules={[
                      {
                        required: isRequiredMeasurement,
                        message: "Please enter Unit value(s)",
                      },
                    ]}
                    label="Unit(s)"
                    name="measurmentValue"
                  >
                    <Input
                      type="number"
                      onChangeCapture={(e) => {
                        if (e) {
                          setIsRequiredMeasurement(true);
                        } else {
                          setIsRequiredMeasurement(false);
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    style={{ marginTop: "43px" }}
                    name="measurmentUnit"
                    rules={[
                      {
                        required: isRequiredMeasurement,
                        message: "Please Select Unit(s)",
                      },
                    ]}
                  >
                    <Select
                      style={{
                        width: "100%",
                      }}
                      onChange={(e) => {
                        if (e) {
                          setIsRequiredMeasurement(true);
                        } else {
                          setIsRequiredMeasurement(false);
                        }
                      }}
                      className="measurmentUnitSelect"
                    >
                      {UNIT?.map((item, index) => (
                        <Select.Option key={index} value={item}>
                          {item}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Tax"
                name="taxId"
                rules={[
                  {
                    required: isRequired,
                    message: "Please Select a Tax",
                  },
                ]}
              >
                <Select
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  style={{
                    width: "100%",
                  }}
                  onChange={(e) => {
                    if (e) {
                      setIsRequired(true);
                    } else {
                      setIsRequired(false);
                    }
                  }}
                >
                  {taxList?.map((tax) => (
                    <Select.Option key={tax.taxId} value={tax.taxId}>
                      {tax.taxName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                rules={[
                  {
                    required: isRequired,
                    message: "Please Select a Inclusive/Exclusive",
                  },
                ]}
                label="Inclusive/Exclusive"
                name={"taxIncExc"}
              >
                <Select
                  displayEmpty
                  style={{
                    width: "100%",
                  }}
                  onChange={(e) => {
                    if (e) {
                      setIsRequired(true);
                    } else {
                      setIsRequired(false);
                    }
                  }}
                >
                  <Select.Option value={"inclusive"}>Inclusive</Select.Option>
                  <Select.Option value={"exclusive"}>Exclusive</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="HSN Code" name={"productHsnCode"}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="cancelButton"
          onClick={() => {
            form.resetFields();
            onClose();
          }}
        >
          Cancel
        </button>
        <button
          className="addAddrButton"
          onClick={() => {
            form.submit();
            //   const product = {
            //     productName: itemBillInput.itemName,
            //     productPrice: itemBillInput.itemRate,
            //     productMrp: itemBillInput.itemMRP,
            //     unitOfMeasurment:
            //       itemBillInput.measurmentValue +
            //       " " +
            //       itemBillInput.measurmentUnit,
            //     discountType: discountType.itemDiscountType,
            //     discountPrice: itemBillInput.itemDiscount,
            //     productWastage: itemBillInput.itemWastage,
            //     productLabour: itemBillInput.itemLabour,
            //     productHsnCode: itemBillInput.itemHsnCode,
            //     productTaxType: itemBillInput.itemTaxType,
            //     productTax: itemBillInput.itemLevelTax,
            //     taxId: itemBillInput.taxId,
            //     productEANCode: itemBillInput.itemEANCode,
            //     taxIncExc: itemBillInput.taxIncExc,
            //     imei1: itemBillInput.imei1,
            //     imei2: itemBillInput.imei2,
            //     count: itemBillInput.itemQuantity,
            //     purchasePrice: itemBillInput.itemPurchasePrice,
            //     isExist: false,
            //   };
            //   if (addedProducts.length !== 0) {
            //     const newItem = JSON.stringify(product);
            //     const products = addedProducts.map(
            //       ({
            //         productName,
            //         isExist,
            //         purchasePrice,
            //         count,
            //         imei2,
            //         taxIncExc,
            //         productEANCode,
            //         taxId,
            //         productTax,
            //         productTaxType,
            //         productPrice,
            //         productMrp,
            //         unitOfMeasurment,
            //         discountType,
            //         discountPrice,
            //         productWastage,
            //         productLabour,
            //         productHsnCode,
            //       }) => {
            //         return JSON.stringify({
            //           productName,
            //           isExist,
            //           purchasePrice,
            //           count,
            //           imei2,
            //           taxIncExc,
            //           productEANCode,
            //           taxId,
            //           productTax,
            //           productTaxType,
            //           productPrice,
            //           productMrp,
            //           unitOfMeasurment,
            //           discountType,
            //           discountPrice,
            //           productWastage,
            //           productLabour,
            //           productHsnCode,
            //         });
            //       }
            //     );
            //     const isExist = products.includes(`{${newItem}}`);
            //     if (isExist) {
            //       return alert("Product already exist");
            //     }
            //   }
            //   formValidation(
            //     {
            //       productId: uuidv4(),
            //       ...product,
            //     },
            //     "fromDec"
            //   );
            //   setToInitialState();
          }}
        >
          ADD ITEM
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddBillModal;
